import { Flex } from '@mantine/core';
import { DashboardSidebar } from '@dealstack/frontend/app/pages/Dashboard/DashboardSidebar';
import { DashboardDeals } from '@dealstack/frontend/app/pages/Dashboard/DashboardDeals/DashboardDeals.tsx';

export const Dashboard = () => {
	return (
		<Flex h="100%">
			<DashboardSidebar />
			<Flex mah="100%" p="2rem" w="100%">
				<DashboardDeals />
			</Flex>
		</Flex>
	);
};
